import { useAuthContext } from "/@/shared/contexts/AuthContext";
import { PhoneUploadQrCard } from "/@/components/order/PhoneUploadQrCard";
import { useQrCodeCanvas } from "/@/components/order/useQrCodeCanvas";

// QR code opening the remote upload page on the user's phone, the files are attached to the order
export const PhoneUploadQrCode = ({ orderId }: { orderId: string }) => {
  const { user } = useAuthContext();
  const canvasRef = useQrCodeCanvas(
    user?.accessToken
      ? `${window.location.origin}/#/orders/${orderId}/files/remote-upload?token=${user.accessToken}`
      : undefined
  );

  return (
    <PhoneUploadQrCard
      canvasRef={canvasRef}
      title="Photos depuis votre téléphone"
      description="Scannez le code : les photos arrivent ici, sans compte ni application."
    />
  );
};
